import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";


@NgModule({
  imports: [
    RouterModule.forRoot([]), 
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
